module.exports = __webpack_public_path__ + "static/media/img-feature-match-200@3x.94752046.png";